var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useWatch } from 'react-hook-form';
import styled from '@emotion/styled';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Alert, Drawer, Flex, Form, theme } from '@robinpowered/ui-kit';
import { CalendarIntegrationsProvider } from '../context/CalendarIntegrationContext';
import { useEventComposerForm } from '../hooks/useEventComposerForm';
import { ErrorModal } from '../components/ErrorModal';
import { CreateFooterButtons } from '../components/CreateFooterButtons';
import { TitleInput } from '../components/TitleInput';
import { PrivacyHeading, PrivacyToggle, } from '../components/toggles/PrivacyToggle';
import { ComposerMode, } from '../types/index';
import { InternalModal } from '../components/InternalModal';
import { useConstant } from '../hooks/useConstant';
import { v4 as uuidv4 } from 'uuid';
import { convertUserToInvitee } from '../utils/utils';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { DateTimeWrapper } from '../components/DateTimeWrapper';
import { SpaceBookingInternal } from '../SpaceBooking/components/SpaceBookingInternal';
import { CreateEventContextProvider, useCreateEventContext, } from './CreateEventContext';
import { EventComposerGlobalProvider, useEventComposerGlobalContext, } from './EventComposerGlobalContext';
import InviteesWrapper from '../components/Invitees/InviteesWrapper';
import { Description } from '../components/Description/Description';
import { EventSpaceWrapper } from '../components/SpaceDetails/EventSpaceWrapper';
import { SuggestedSpaceCreatePrompt } from '../components/SpaceDetails/SuggestedSpacePrompt';
import { CalendarSelector } from '../components/CalendarSelector';
var CreateEventComposerWrapper = function () {
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var _a = useEventComposerGlobalContext(), requestOnlySpace = _a.requestOnlySpace, levelId = _a.levelId;
    var _b = useCreateEventContext(), handleEventCreation = _b.handleEventCreation, initialEvent = _b.initialEvent, fetchingSpace = _b.fetchingSpace, createEventError = _b.createEventError, creatingEvent = _b.creatingEvent, setCreateEventError = _b.setCreateEventError, setCompletedSpaceRequestFormId = _b.setCompletedSpaceRequestFormId, shouldShowPrivacyIndicator = _b.shouldShowPrivacyIndicator, spaceReservationVisibilityEnabled = _b.spaceReservationVisibilityEnabled;
    var _c = __read(useWatch({
        name: ['spaces'],
    }), 1), spaces = _c[0];
    var showSuggestedSpace = !fetchingSpace && !(spaces === null || spaces === void 0 ? void 0 : spaces.length) && !!levelId;
    return (_jsxs(_Fragment, { children: [createEventError && createEventError.error && (_jsx(ErrorModal, { onCancel: function () {
                    setCreateEventError(null);
                }, onAction: function () {
                    if (createEventError === null || createEventError === void 0 ? void 0 : createEventError.isPersonalCalendarError) {
                        window.open('/account/integrations', '_blank');
                        setCreateEventError(null);
                    }
                    else {
                        handleEventCreation();
                    }
                }, actionText: (createEventError === null || createEventError === void 0 ? void 0 : createEventError.isPersonalCalendarError)
                    ? t('go_to_integrations')
                    : t('create_event.retry'), actionType: (createEventError === null || createEventError === void 0 ? void 0 : createEventError.isPersonalCalendarError) ? 'primary' : 'danger', composingEvent: (createEventError === null || createEventError === void 0 ? void 0 : createEventError.isPersonalCalendarError) ? false : creatingEvent, errorMessages: (createEventError === null || createEventError === void 0 ? void 0 : createEventError.error) || [], errorHeading: t('create_event.error_heading') })), _jsxs(StyledColumn, { children: [_jsxs(Form, { layout: "vertical", children: [_jsx(CalendarSelector, {}), _jsx(TitleInput, { isRequestOnlyEvent: !!requestOnlySpace }), _jsx(DateTimeWrapper, { requestOnlySpace: requestOnlySpace }), _jsx(InviteesWrapper, { hideInvitees: !!requestOnlySpace }), showSuggestedSpace && (_jsx(SuggestedSpaceCreatePrompt, { levelId: levelId })), _jsx(EventSpaceWrapper, { isLoadingEvent: false, initialEvent: initialEvent, fetchingSpace: fetchingSpace, checkSpaceDeletionPermission: function () { return true; }, setCompletedSpaceRequestFormId: setCompletedSpaceRequestFormId }), !!requestOnlySpace && (_jsx(Alert, { style: { alignItems: 'flex-start', marginBottom: '24px' }, message: t('create_event.request_only_note'), type: "warning", showIcon: false })), _jsx(Description, {}), shouldShowPrivacyIndicator && (_jsxs(PrivacyIndicator, { children: [_jsx(FontAwesomeIcon, { icon: faLock, color: token.colorIcon }), _jsx(PrivacyHeading, { strong: true, children: t('events.private') })] }))] }), _jsxs(BottomRow, { style: {
                            borderTop: "1px solid ".concat(token.colorBorderSecondary),
                            backgroundColor: token.colorWhite,
                        }, children: [spaceReservationVisibilityEnabled && _jsx(PrivacyToggle, {}), _jsx(CreateFooterButtons, {})] })] })] }));
};
var StyledDrawer = styled(Drawer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-drawer-header-title {\n    align-items: center;\n    display: flex;\n    flex-direction: row-reverse;\n  }\n\n  .ant-form {\n    padding-bottom: 20px !important;\n    margin-bottom: 16px;\n  }\n\n  .ant-drawer-body {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n  }\n"], ["\n  .ant-drawer-header-title {\n    align-items: center;\n    display: flex;\n    flex-direction: row-reverse;\n  }\n\n  .ant-form {\n    padding-bottom: 20px !important;\n    margin-bottom: 16px;\n  }\n\n  .ant-drawer-body {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n  }\n"])));
var StyledColumn = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: -1px;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 50px;\n"], ["\n  margin-top: -1px;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 50px;\n"])));
var BottomRow = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 16px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  padding: 16px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
// @TODO Add this when we're able to get the space setting.slug
var PrivacyIndicator = styled(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n  padding-bottom: 16px;\n"], ["\n  align-items: center;\n  padding-bottom: 16px;\n"])));
/**
 * Internal implementation of CreateEventComposer.
 * Assumes all required contexts (ApolloProvider, etc.) are already present.
 */
export var CreateEventComposerInternal = function (_a) {
    var _b;
    var props = __rest(_a, []);
    var t = useTranslation('meetingRooms').t;
    var onError = props.onError, event = props.event, onClose = props.onClose, onSubmit = props.onSubmit, onEventChange = props.onEventChange, selectedTimezone = props.selectedTimezone, timeFormat = props.timeFormat, config = props.config, 
    // initialEvent: immutable reference point for both modes
    initialEvent = props.initialEvent, 
    // event: parent-controlled event data (CREATE mode only)
    // This allows parent to update form values via props -> event
    parentEvent = props.event, onTrackBufferEvent = props.onTrackBufferEvent;
    var tModal = useTranslation('modal').t;
    var eventUid = useConstant(function () { return uuidv4(); });
    var _c = __read(useState(false), 2), discardModal = _c[0], setDiscardModal = _c[1];
    var currentUser = config.userContext.currentUser;
    /* Only for create mode */
    var invitees = useMemo(function () {
        var _a;
        return ((parentEvent === null || parentEvent === void 0 ? void 0 : parentEvent.invitees) ||
            (currentUser
                ? [
                    convertUserToInvitee({
                        name: currentUser.name,
                        avatar: currentUser.avatar,
                        id: parseInt(currentUser.id),
                        primaryEmail: {
                            email: (_a = currentUser.primaryEmail) === null || _a === void 0 ? void 0 : _a.email,
                        },
                    }),
                ]
                : []));
    }, [parentEvent, currentUser]);
    var onDiscardChangesModalDiscard = useCallback(function () {
        setDiscardModal(true);
        onClose();
    }, [onClose, setDiscardModal]);
    /* Set initial form values from initialEvent (or event in CREATE mode) */
    // In CREATE mode: use event prop if available (parent-controlled), otherwise initialEvent
    // In EDIT mode: use initialEvent (eventToBeUpdated from API)
    var initialFormValues = useMemo(function () {
        var eventData = initialEvent;
        return {
            title: (eventData === null || eventData === void 0 ? void 0 : eventData.title) || '',
            startTime: (eventData === null || eventData === void 0 ? void 0 : eventData.startTime) || moment().tz(selectedTimezone),
            endTime: (eventData === null || eventData === void 0 ? void 0 : eventData.endTime) || moment().add(1, 'hour').tz(selectedTimezone),
            date: (eventData === null || eventData === void 0 ? void 0 : eventData.date) || moment().tz(selectedTimezone),
            isAllDayEvent: !!(eventData === null || eventData === void 0 ? void 0 : eventData.isAllDayEvent),
            invitees: invitees,
            recurrenceRule: null,
            description: eventData === null || eventData === void 0 ? void 0 : eventData.description,
            // In CREATE mode, spaces are not available from event/initialEvent (only spaceIds)
            spaces: undefined,
            scheduleConfiguration: eventData === null || eventData === void 0 ? void 0 : eventData.scheduleConfiguration,
            attendeeCount: (eventData === null || eventData === void 0 ? void 0 : eventData.attendeeCount) || 1,
            generateTeamsLink: (eventData === null || eventData === void 0 ? void 0 : eventData.hasTeamsLink) || false,
            /* @TODO EventID can be undefined in CREATE mode */
            eventId: (eventData === null || eventData === void 0 ? void 0 : eventData.id) || '',
            isPrivateEvent: (eventData === null || eventData === void 0 ? void 0 : eventData.isPrivate) || false,
            /* Event UID must always be set */
            uid: (eventData === null || eventData === void 0 ? void 0 : eventData.uid) || eventUid,
            spacesWithConflicts: undefined,
            spaceBuffers: undefined,
            videoIntegrationId: undefined,
        };
    }, [initialEvent, invitees, eventUid, selectedTimezone]);
    var methods = useEventComposerForm(initialFormValues, ComposerMode.CREATE).methods;
    // Memoize all error callbacks to prevent child providers' useEffects from re-running
    var handleError = useCallback(function (errorMessage) {
        onError === null || onError === void 0 ? void 0 : onError(new Error(errorMessage), ComposerMode.CREATE);
    }, [onError]);
    var handleEventComposerContextError = useCallback(function (error) {
        onError === null || onError === void 0 ? void 0 : onError(error, ComposerMode.CREATE);
    }, [onError]);
    var formKey = "create:".concat(initialFormValues.uid);
    var _d = __read(useState(false), 2), spaceBookingOpen = _d[0], setSpaceBookingOpen = _d[1];
    var defaultLevelId = (_b = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.levelId) === null || _b === void 0 ? void 0 : _b.toString();
    return (_createElement(FormProvider, __assign({}, methods, { key: formKey }),
        _jsx(CalendarIntegrationsProvider, { onError: handleError, children: _jsxs(EventComposerGlobalProvider, { composerMode: ComposerMode.CREATE, timezone: selectedTimezone, timeFormat: timeFormat, onError: handleEventComposerContextError, setSpaceBookingOpen: function (open) { return setSpaceBookingOpen(open); }, onTrackBufferEvent: onTrackBufferEvent, defaultLevelId: defaultLevelId, children: [_jsxs(StyledDrawer, { title: t('create_event.new_event_title'), onClose: function () {
                            if (methods.formState.isDirty) {
                                setDiscardModal(true);
                            }
                            else {
                                onClose();
                            }
                        }, open: true, placement: "right", mask: false, children: [discardModal && (_jsx(InternalModal, { onCancel: function () { return setDiscardModal(false); }, onConfirm: onDiscardChangesModalDiscard, title: tModal('discard_modal.heading'), byline: tModal('discard_modal.byline'), confirmText: tModal('discard_modal.confirm'), cancelText: tModal('discard_modal.cancel') })), _jsx(CreateEventContextProvider, { onClose: onClose, onSubmit: onSubmit, onEventChange: onEventChange, initialEvent: initialEvent, parentEvent: event, children: _jsx(CreateEventComposerWrapper, {}) })] }), spaceBookingOpen && (_jsx(SpaceBookingInternal, { open: spaceBookingOpen, setSpaceBookingOpen: setSpaceBookingOpen, onError: handleError }))] }) })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
